import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { useHomeT } from '../i18n/strings';

export default function SiteNav() {
  const { lang, setLV, setEN } = useLanguage();
  const t = useHomeT(lang);
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();
  const home = loc.pathname === '/';

  const anchor = (id) => (home ? `#${id}` : `/#${id}`);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className="gdwd-nav" aria-label="Primary">
        <div className="gdwd-container gdwd-nav__inner">
          <Link to="/" className="gdwd-logo" onClick={close}>
            gdwd<span>.</span>
          </Link>
          <div className="gdwd-nav__links">
            <Link to={anchor('products')}>{t.navProducts}</Link>
            <Link to={anchor('platforms')}>{t.navPlatforms}</Link>
            <Link to={anchor('mobile')}>{t.navMobile}</Link>
            <Link to="/work">{t.navWork}</Link>
            <Link to={anchor('about')}>{t.navAbout}</Link>
            <Link to={anchor('contact')}>{t.navContact}</Link>
          </div>
          <div className="gdwd-nav__right">
            <div className="gdwd-lang" role="group" aria-label="Language">
              <button type="button" className={lang === 'lv' ? 'is-active' : ''} onClick={setLV}>
                LV
              </button>
              <button type="button" className={lang === 'en' ? 'is-active' : ''} onClick={setEN}>
                EN
              </button>
            </div>
            <Link to={anchor('contact')} className="gdwd-btn gdwd-btn--primary">
              {t.navCta}
            </Link>
            <button
              type="button"
              className="gdwd-burger"
              aria-label={menuOpen ? t.menuClose : t.menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </nav>

      <div className={`gdwd-menu${menuOpen ? ' is-open' : ''}`} aria-hidden={!menuOpen}>
        <div className="gdwd-menu__top">
          <Link to="/" className="gdwd-logo" style={{ color: '#E8EEF7' }} onClick={close}>
            gdwd<span>.</span>
          </Link>
          <button type="button" className="gdwd-burger" style={{ color: '#fff' }} onClick={close} aria-label={t.menuClose}>
            ✕
          </button>
        </div>
        <div className="gdwd-lang" style={{ alignSelf: 'flex-start', marginBottom: 16 }}>
          <button type="button" className={lang === 'lv' ? 'is-active' : ''} onClick={setLV}>
            LV
          </button>
          <button type="button" className={lang === 'en' ? 'is-active' : ''} onClick={setEN}>
            EN
          </button>
        </div>
        <Link to={anchor('products')} onClick={close}>
          {t.navProducts}
        </Link>
        <Link to={anchor('platforms')} onClick={close}>
          {t.navPlatforms}
        </Link>
        <Link to={anchor('mobile')} onClick={close}>
          {t.navMobile}
        </Link>
        <Link to="/work" onClick={close}>
          {t.navWork}
        </Link>
        <Link to={anchor('about')} onClick={close}>
          {t.navAbout}
        </Link>
        <Link to={anchor('contact')} onClick={close}>
          {t.navContact}
        </Link>
        <Link to={anchor('contact')} className="gdwd-btn gdwd-btn--primary" style={{ marginTop: 24 }} onClick={close}>
          {t.navCta}
        </Link>
      </div>
    </>
  );
}
